module.exports = __webpack_public_path__ + "assets/img/dd2361d2dbc80f3387efd7cab3ba10ea.svg";